import { OfferedQuantityDiscountBase } from '../json-schemas/base/offered_quantity_discount'
import { I18nService } from '../utils/i18n.service'

const i18nScoped = new I18nService(require('./offered-quantity-discounts.service.yml'))

export function offeredQuantityDiscountsI18nQuantityWithUnit (quantity: number, unitOfWork: OfferedQuantityDiscountBase['unit_of_work']) {
  return i18nScoped.t(`quantity_commitment_with_unit.${unitOfWork}`, { count: quantity })
}

export function offeredQuantityDiscountsI18nQuantityCommitmentLabel (unitOfWork: OfferedQuantityDiscountBase['unit_of_work']) {
  return i18nScoped.t(`quantity_commitment_label.${unitOfWork}`)
}